import moment from "moment";
import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { DatePicker, Input, SelectPicker, Tag } from "rsuite";
import Pagination from "rsuite/Pagination";
import { userAtom } from "../../../Atoms/user.atom";
import { checkoutsAtom } from "../../../Atoms/checkouts.atom";
import { APi } from "../../../Api";
import format_number from "../../../Helpers/number_formatter";
import {
  dateTypes,
  serviceTypes,
  StatusPaiment,
} from "../../../Constants/types";
import Responsive from "../../../Components/Responsive";
import ResumeCard from "../../../Components/ResumeCard";
import Grid from "../../../Components/Grid";
import ListTransactions from "../../JournalCheckout/ListTransactions";
import AddMontantModal from "../../../Components/modal/AddMontantModal";

export default function TransactionsClients(props) {
  const [data, setdata] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalLeftToPay, setTotalLeftToPay] = useState(0);
  const user = useRecoilValue(userAtom);
  const [transactionsData, setTransactionsData] = useState([]);
  const [transaction, setTransaction] = useState(null);
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const [filterModel, setfilterModel] = useState({
    name: "",
    page: 1,
    take: 20,
    service: 0,
    clientId: 0,
    checkoutId: 0,
    date: null,
    dateType: 0,
    status: null,
    seasonId: 0,
  });
  const [checkouts, setcheckouts] = useRecoilState(checkoutsAtom);

  const fetch = (_take) => {
    APi.createAPIEndpoint(
      APi.ENDPOINTS.Transaction + "/GetALLTransactionParent",
      {
        ...filterModel,
        checkoutId: props.checkoutId
          ? props.checkoutId
          : filterModel.checkoutId,
        take: _take || filterModel.take,
      }
    )
      .fetchAll()
      .then((res) => {
        setdata(
          res.data.data.map((_, i) => ({
            ..._,
          }))
        );
        settotalCount(res.data.totalCount);
        setTotal(res.data.sumTotalPrice);
        setTotalLeftToPay(res.data.sumAmountToBePaid);
      })
      .catch((e) => {
        setError(e.Message);
      });
  };

  const displayAction = (id) => {
    APi.createAPIEndpoint(
      APi.ENDPOINTS.Transaction +
        `/GetTransactionParentByIdWithTransactions/${id}`
    )
      .fetchAll()
      .then((res) => {
        console.log(res, "res");
        setTransactionsData(res.data.transactions);
        setTransaction(res.data);
      })
      .catch((e) => {
        console.error(e);
        setTransactionsData([]);
      });
  };

  useEffect(() => {
    fetch();
  }, [filterModel]);

  const columns = [
    {
      value: "date",
      name: "Date",

      render: (v) => (
        <h6
          style={{
            fontSize: "12px",
          }}
        >
          {moment(v).format("DD MMM YYYY")}
        </h6>
      ),
    },

    {
      value: "infosB2C",
      name: "Client",
      render: (v) => (
        <b style={{ color: "#4c67c2" }}>{v ? v.fullName.toUpperCase() : "-"}</b>
      ),
    },

    {
      value: "amount",
      name: "Totale",
      render: (v) => (
        <b style={{ fontSize: "14px", color: "#549f0a" }}>
          {v ? format_number(v) : ""}
        </b>
      ),
    },
    {
      value: "amountToBePaid",
      name: "Reste à payé",
      render: (v) => (
        <b style={{ fontSize: "14px" }}>{format_number(v || 0)}</b>
      ),
    },

    {
      value: "paymentStatus",
      name: "Status",
      render: (v) => (
        <b style={{ fontSize: "14px", color: v === 1 && "#549f0a" }}>
          {v === 0 ? "Partiellement payé" : "Payé"}
        </b>
      ),
    },

    {
      value: "checkout",
      name: "Caisse",
      render: (v) => (
        <b style={{ color: "#4c67c2" }}>{v ? v.name.toUpperCase() : "-"}</b>
      ),
    },

    {
      value: "service",
      name: "Service",
      render: (v) =>
        v ? (
          <Tag
            color={
              v == 1
                ? "blue"
                : v == 2
                ? "green"
                : v == 3
                ? "red"
                : v == 4
                ? "black"
                : v == 5
                ? "orange"
                : v == 6
                ? "violet"
                : v == 7
                ? "yellow"
                : "teal"
            }
          >
            {serviceTypes.find((el) => el.value == v)
              ? serviceTypes.find((el) => el.value == v).label
              : "Autres"}
          </Tag>
        ) : (
          "-"
        ),
    },
  ];

  const handleDateTypeSelection = (dateType) => {
    let today = new Date(moment(Date.now()).format("yyyy-MM-DD"));

    setfilterModel((prev) => {
      return {
        ...prev,
        dateType,
        date:
          dateType == 7 || dateType == 1
            ? today
            : dateType == 2
            ? moment(moment(Date.now()).add(-1, "d")).format("yyyy-MM-DD")
            : null,
        dateFrom:
          dateType == 6
            ? today
            : dateType == 3
            ? moment().startOf("month").format("yyyy-MM-DD")
            : dateType == 4
            ? moment(Date.now())
                .subtract(1, "months")
                .startOf("month")
                .format("yyyy-MM-DD")
            : dateType == 5
            ? moment().startOf("year").format("yyyy-MM-DD")
            : null,
        dateTo:
          dateType == 6
            ? new Date(
                moment(moment(Date.now()).add(1, "d")).format("yyyy-MM-DD")
              )
            : dateType == 3
            ? today
            : dateType == 4
            ? moment(Date.now())
                .subtract(1, "months")
                .endOf("month")
                .format("yyyy-MM-DD")
            : null,
      };
    });
  };

  return (
    <div>
      <Responsive m={12} l={12} xl={12} className="p-5">
        <label>Recherche: </label>
        <Input
          placeholder="recherche"
          onChange={(name) => {
            setfilterModel((prev) => {
              return { ...prev, name };
            });
          }}
        />
      </Responsive>
      <Responsive m={6} l={3} xl={3} className="p-5">
        <label>Dates: </label>
        <SelectPicker
          data={dateTypes}
          block
          noSearch
          value={filterModel.dateType}
          onSelect={(dateType) => handleDateTypeSelection(dateType)}
        />
      </Responsive>
      {filterModel.dateType == 7 && (
        <Responsive m={6} l={3} xl={3} className="p-5">
          <label>Date: </label>
          <Input
            type="date"
            value={filterModel.date}
            onChange={(date) => {
              setfilterModel((prev) => {
                return { ...prev, date };
              });
            }}
          />
        </Responsive>
      )}
      {filterModel.dateType == 6 && (
        <Responsive m={6} l={3} xl={3} className="p-5">
          <label>Plage du temps: </label>
          <div>
            <Responsive m={6} l={6} xl={6} className="px-5">
              <DatePicker
                style={{ display: "block" }}
                format="dd/MM/yyyy"
                onChange={(dateFrom) => {
                  setfilterModel((prev) => {
                    return {
                      ...prev,
                      dateFrom,
                    };
                  });
                }}
              />
            </Responsive>
            <Responsive m={6} l={6} xl={6} className="px-5">
              <DatePicker
                style={{ display: "block" }}
                format="dd/MM/yyyy"
                onChange={(dateTo) => {
                  setfilterModel((prev) => {
                    return {
                      ...prev,
                      dateTo,
                    };
                  });
                }}
              />
            </Responsive>
          </div>
        </Responsive>
      )}
      {user && !props.checkoutId && (
        <Responsive m={6} l={3} xl={3} className="p-5">
          <label>Caisse: </label>
          <SelectPicker
            data={[{ label: "Tout", value: 0 }].concat(
              checkouts.map((el) => {
                return { value: el.id, label: el.name.toUpperCase() };
              })
            )}
            block
            noSearch
            value={filterModel.checkoutId}
            onSelect={(checkoutId) => {
              setfilterModel((prev) => {
                return { ...prev, checkoutId };
              });
            }}
          />
        </Responsive>
      )}

      <Responsive m={6} l={3} xl={3} className="p-5">
        <label>Service: </label>
        <SelectPicker
          searchable={false}
          data={[
            {
              label: "Tout",
              value: 0,
            },
            {
              label: "Voyage Organisé",
              value: 6,
            },
            {
              label: "Omrah",
              value: 7,
            },
          ]}
          block
          noSearch
          value={filterModel.service}
          onSelect={(service) => {
            setfilterModel((prev) => {
              return { ...prev, service };
            });
          }}
        />
      </Responsive>

      <Responsive m={6} l={3} xl={3} className="p-5">
        <label>Status: </label>
        <SelectPicker
          searchable={false}
          data={StatusPaiment}
          block
          noSearch
          value={filterModel.status}
          onSelect={(status) => {
            setfilterModel((prev) => {
              return { ...prev, status };
            });
          }}
        />
      </Responsive>

      <div>
        <Responsive className="p-10" m={6} l={3} xl={3}>
          <ResumeCard
            text="Total"
            color="0,169,141"
            amount={totalCount}
            notAmount
          />
        </Responsive>
        <Responsive className="p-10" m={6} l={3} xl={3}>
          <ResumeCard text="Total" color="245,195,35" amount={total} />
        </Responsive>
        <Responsive className="p-10" m={6} l={3} xl={3}>
          <ResumeCard
            text="Total Payé"
            amount={total - totalLeftToPay}
            color="229,57,53"
          />
        </Responsive>
        <Responsive className="p-10" m={6} l={3} xl={3}>
          <ResumeCard
            text="Total Reste à Payé"
            amount={totalLeftToPay}
            color="60,16,83"
          />
        </Responsive>
      </div>
      <Grid
        displayAction={(id) => {
          displayAction(id);
          setShow(true);
        }}
        editAction={(id) => {
          displayAction(id);
          setOpen(true);
        }}
        actionKey="id"
        noAdvancedActions
        columns={columns}
        rows={data}
      />
      <div style={{ padding: 20, background: "#fff" }}>
        <Pagination
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="md"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={totalCount}
          limitOptions={[10, 20, 50, 100]}
          limit={filterModel.take}
          activePage={filterModel.page}
          onChangePage={(page) => {
            window.scrollTo(0, 0);
            setfilterModel((prev) => {
              return { ...prev, page };
            });
          }}
          onChangeLimit={(take) => {
            setfilterModel((prev) => {
              return { ...prev, take, page: 1 };
            });
          }}
        />
      </div>
      <ListTransactions
        show={show}
        close={() => setShow(false)}
        data={transactionsData}
      />
      <AddMontantModal
        open={open}
        handleClose={() => setOpen(false)}
        data={transaction}
        fetch={fetch}
      />
    </div>
  );
}
